import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as Logo } from "../assets/hujan.svg";
import { appdata } from "../models/appdata";

const HeaderPart = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 3,
        }}
      >
        <Typography
          variant="h4"
          color="primary"
          sx={{ fontWeight: "bold", textAlign: "center" }}
        >
          {appdata.judulMain}
        </Typography>
        <Typography
          sx={{ textAlign: "center" }}
          variant="h6"
          color="text.secondary"
        >
          {appdata.judulSecond}
        </Typography>
        <Paper sx={{ m: 1 }}>
          <Typography variant="subtitle1" sx={{ textAlign: "justify", mt: 2 }}>
            {appdata.ketJudul}
          </Typography>
        </Paper>
      </Box>
    </>
  );
};

export default HeaderPart;
